export default {
    isLoggedIn(state){
        return !!state.userId
    }
  };
  